/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HotelEditSingleHasMinDaysRestrictionApiRequest } from '../../models/hotel-edit-single-has-min-days-restriction-api-request';

export interface ApiHotelManageEditSingleMindaysRestrictionPost$Params {
      body: HotelEditSingleHasMinDaysRestrictionApiRequest
}

export function apiHotelManageEditSingleMindaysRestrictionPost(http: HttpClient, rootUrl: string, params: ApiHotelManageEditSingleMindaysRestrictionPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiHotelManageEditSingleMindaysRestrictionPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiHotelManageEditSingleMindaysRestrictionPost.PATH = '/api/hotel/manage/edit/single/mindays-restriction';
